import { render, staticRenderFns } from "./NavbarInfo.vue?vue&type=template&id=1bf490df&"
import script from "./NavbarInfo.vue?vue&type=script&lang=js&"
export * from "./NavbarInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports